import Column from '@components/column'
import Typography from '@components/typography'
import { FC } from 'react'
import Tabs from '@commons/tabs'
import Identifications from './identitications'
import Licenses from './licenses'
import Signature from './signature'
import BusinessRegistration from './registrations'
interface DocumnetsProps {
  identifications: any[]
  licenses: any[]
  registrations?: any[]
  setFieldValue: any
  disabled?: boolean
  role?: 'doctor' | 'institution'
}
const Documents: FC<DocumnetsProps> = ({
  identifications,
  registrations,
  licenses,
  disabled,
  setFieldValue,
  role,
}) => {
  const tabs: any = [
    {
      title: 'Identification',
      key: 'identification',
      Component: Identifications,
      props: {
        identifications,
        disabled,
      },
    },
    {
      title: 'Medical License',
      key: 'license',
      Component: Licenses,
      props: {
        licenses,
        disabled,
        setFieldValue,
      },
    },
    role == 'institution' && {
      title: 'Business Registration',
      key: 'business-registration',
      Component: BusinessRegistration,
      props: {
        registrations,
        disabled,
        setFieldValue,
      },
    },
    {
      title: 'Signature',
      key: 'signature',
      Component: Signature,
      props: {
        disabled,
      },
    },
  ].filter((tab) => !!tab)
  return (
    <Column
      bg={'white'}
      styleColumn="padding:20px;border-radius:8px;"
      rowGap={20}
    >
      <Typography content="Documents" size={16} tc="text" />
      <Tabs
        items={tabs}
        styleWrapper="
        div{
          border:1px solid #E9E9E9;
        }
      "
      />
    </Column>
  )
}

export default Documents
